import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager } from "../../../../utils"

export const citybyStateTodo = createAsyncThunk('citybyState', async ({ id, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `city_by_state/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})


const citybyStateSlice = createSlice({
    name: 'citybyState',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(citybyStateTodo.fulfilled, (state, action) => {
            if (action.payload && action.payload.status == 200) {
                state.data = action.payload.data.data;
            } else {
                state.data = []
            }

        });
        builder.addCase(citybyStateTodo.rejected, (state, action) => {

        })
    }
})

export default citybyStateSlice.reducer; 